export const REGISTER_USER = 'REGISTER_USER'
export const SIGNIN_USER = 'SIGNIN_USER'
export const RESET_PASSWORD = 'RESET_PASSWORD'
export const UPDATE_USER_INFORMATIONS = 'UPDATE_USER_INFORMATIONS'
export const VALIDATE_ACCOUNT = 'VALIDATE_ACCOUNT'
export const SET_USER_LOGGED = 'SET_USER_LOGGED'
export const SET_USER_INFORMATIONS = 'SET_USER_INFORMATIONS'
export const SET_FORM_USER_INFORMATIONS = 'SET_FORM_USER_INFORMATIONS'
export const RESEND_CONFIRMATION_CODE = 'RESEND_CONFIRMATION_CODE'
export const LOGOUT = 'LOGOUT'
export const CONFIRM_RESET_PASSWORD = 'CONFIRM_RESET_PASSWORD'

export const LOAD_COMMANDS = 'LOAD_COMMANDS'
export const SET_COMMANDS = 'SET_COMMANDS'
export const GET_COMMANDS = 'GET_COMMANDS'

export const SET_ID_TOKEN = 'SET_ID_TOKEN'

export const SET_KEEP_OFFLINE_MODE = 'SET_KEEP_OFFLINE_MODE'

export const SEND_GIFT_EMAIL = 'SEND_GIFT_EMAIL'